var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStepperCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.516.26L7.953 10.99l-5.78-4.647L.006 9.13l7 5.63 1.221.98 1.103-1.12L20.995 2.77 18.517.259z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE4LjUxNi4yNkw3Ljk1MyAxMC45OWwtNS43OC00LjY0N0wuMDA2IDkuMTNsNyA1LjYzIDEuMjIxLjk4IDEuMTAzLTEuMTJMMjAuOTk1IDIuNzcgMTguNTE3LjI1OXoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
export { SvgStepperCheckMark as ReactComponent };